import { Field } from "formik";
import { Form } from "react-bootstrap";
import * as Yup from "yup";
// SubForms
import { NameSubForm, Schema as NameSchema } from '../subforms/Name';
import { AdditionalNotesSubForm, Schema as AdditionalNotesSchema } from '../subforms/AdditionalNotes';
import { DocumentsInternalSubForm, Schema as DocumentsInternalSchema } from '../subforms/DocumentsInternal';

export const StadtwerkeSpeyerInternSchema = (settings) => (
    Yup.object()
        .concat(NameSchema(settings))
        .concat(AdditionalNotesSchema(settings))
        .concat(DocumentsInternalSchema(settings))
);

export const StadtwerkeSpeyerIntern = (props) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Text muted>Die im Folgenden mit * markierten Felder sind Pflichtfelder.</Form.Text>
            <Field component={NameSubForm} colors={colors} settings={settings} />
            <Field component={AdditionalNotesSubForm} colors={colors} settings={settings} />
            <Field component={DocumentsInternalSubForm} colors={colors} settings={settings} />
        </>
    );
}